import React, { useEffect } from "react";
import translate from "i18n/translate";
import { Typography, SrTitle } from "components/common";
import TransferBetweenUsersForm from "./TransferBetweenUsersForm";
import useStyles from "./transferBetweenUsersStyles";
import { View } from "../../../../utils";
import { useDispatch } from "react-redux";
import { startFundsAutoUpdate } from "redux/app/actions/funds.action";

const TransferBetweenUsers = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(startFundsAutoUpdate(true));
  }, [dispatch]);

  return (
    <View translateTitleKey="menu.transfersBetweenUsers">
      <SrTitle>{translate("transferBtwUsers.title")}</SrTitle>
      <Typography variant="body1SemiBold" className={classes.formTitle}>
        {translate("transferBtwUsers.sendMoneyToOthers")}
      </Typography>
      <TransferBetweenUsersForm />
    </View>
  );
};

export default TransferBetweenUsers;
